import React from 'react'
import { Box, Divider, Paper, Skeleton, Stack, Typography } from '@mui/material'

export const EMobilityPageSkeleton: React.FC = () => (
  <Box>
    <Stack direction="row" justifyContent="space-between" alignItems="center" py={1.5} rowGap={2} flexWrap="wrap">
      <Typography variant="h2">
        <Skeleton width={200} />
      </Typography>

      <Stack direction="row" rowGap={2} columnGap={2} flexWrap="wrap">
        {[1, 2, 3, 4].map(i => (
          <Skeleton
            key={i}
            variant="rounded"
            height={54}
            width={100}
            sx={{
              bgcolor: theme => theme.palette.background.paper,
              borderRadius: 1,
              boxShadow: theme => theme.shadows[1],
            }}
          />
        ))}
      </Stack>
    </Stack>

    <Divider sx={{ borderColor: 'divider' }} />

    <Box px={3} pt={2}>
      <Typography variant="h3">
        <Skeleton width={120} />
      </Typography>

      <Stack direction="row" gap={1.5} flexWrap="wrap" pt={4}>
        {[1, 2, 3].map(i => (
          <Skeleton
            key={i}
            variant="rounded"
            height={90}
            width={200}
            sx={{
              bgcolor: theme => theme.palette.background.paper,
              borderRadius: 1,
              boxShadow: theme => theme.shadows[1],
            }}
          />
        ))}
      </Stack>

      <Typography variant="h3" pt={3}>
        <Skeleton width={250} />
      </Typography>

      <Box sx={{ pt: 4 }}>
        <Paper sx={{ p: 1 }}>
          <Stack direction={'row'} alignItems="stretch" justifyContent={'space-between'} spacing={1.5} pt={1.5}>
            {[1, 2, 3, 4, 5].map(i => (
              <Skeleton key={i} variant="rectangular" width={'100%'} />
            ))}
          </Stack>

          <Stack pt={2} gap={0.5}>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => (
              <Box
                key={i}
                sx={{
                  borderBottom: theme => `1px solid ${theme.palette.divider}`,
                  py: 1,
                  px: 2,
                }}
              >
                <Skeleton variant="rectangular" />
              </Box>
            ))}
          </Stack>

          <Box py={0.5}>
            <Skeleton variant="text" width={100} sx={{ ml: 'auto' }} />
          </Box>
        </Paper>
      </Box>
    </Box>
  </Box>
)
